import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),
      children: [
        {
          name: "HomePage",
          path: "",
          component: () => import("@/views/dashboard/homePage/Landing"),
        },
        {
          name: "CheckOuts",
          path: "CheckOuts",
          component: () => import("@/views/dashboard/homePage/HomePage"),
        },
        {
          name: "takeOut",
          path: "takeOut",
          component: (a) => import("@/views/dashboard/homePage/takeOut"),
        },
        {
          name: "add",
          path: "add",
          component: (a) => import("@/views/dashboard/homePage/addProduct"),
        },
        {
          name: "viewStock",
          path: "viewStock",
          component: (a) => import("@/views/dashboard/homePage/viewStock"),
        }, // viewStock
        {
          name: "getItems",
          path: "getItems",
          component: (a) => import("@/views/dashboard/homePage/getItems"),
        }, // viewStock
        {
          name: "backup",
          path: "backup",
          component: (a) => import("@/views/dashboard/homePage/backup"),
        }, // viewStock
        {
          name: "backupView",
          path: "backupView",
          component: (a) => import("@/views/dashboard/homePage/backupView"),
        }, // viewStock
      ],
    },
    {
      path: "/Login",
      component: () => import("@/views/dashboard/homePage/Login"),
    },
    {
      path: "*",
      component: () => import("@/views/dashboard/homePage/Login"),
    },
  ],
});
